import styled from "../../../../styled";

export const StyledGroup = styled.div`
  font-size: 13px;
`;
